export const DEFAULT_ASIDE_WIDTH = 400;
export const MIN_ASIDE_WIDTH = 240;
